import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import visitorService from "./visitorService";

const initialState = {
  visitor: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

export const trackVisitor = createAsyncThunk(
  "visitor/track",
  async (visitorData, thunkAPI) => {
    try {
      return await visitorService.trackVisitor(visitorData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const visitorSlice = createSlice({
  name: "visitor",
  initialState,
  reducers: {
    resetVisitorState: (state) => {
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(trackVisitor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(trackVisitor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.visitor = action.payload;
        console.log(action.payload);
      })
      .addCase(trackVisitor.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message =
          action.error?.message || "Failed to track visitor";
      });
  },
});

export const { resetVisitorState } = visitorSlice.actions;

export default visitorSlice.reducer;
